import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { DateTime } from 'luxon';
import Genres from './components/genres/genres';
import AudioBox from './components/audio/audiobox';
import Pagination from './components/pagination/pagination';
import Share from './components/share/share';

import Avatar from './components/upload/avatar';
import Cover from './components/upload/cover';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
//import Form from 'react-bootstrap/Form';

import './css/profile.css';
import { ButtonGroup } from 'react-bootstrap';

var newday = -1;
function ScheduleDate({schedule}) {
	const x = new Date(schedule.start*1000);
	if( x.getDay() !== newday ) {
		newday = x.getDay();
		return (
			<div className="col-12 mt-3">
				<div className="p-schedule-event-add">
					<div className="p-schedule-day p-2">
						{moment(schedule.start*1000).format("dddd Do MMMM")}
					</div>
				</div>
			</div>
		)
	} else return <></>;
}

export default class Profile extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);

    this.state = {
			status: false,
			imageadd: false,
			coveradd: false,
			profile: decodeURI(window.location.pathname.match(/\/(.*)/)[1]),
			user: {},
			schedule: {},
			genres: {},
			sets: {},

			page: 0,
			filter: 'Recent',
			pagination: {},
			donations: {},
			friends: {
				common: [],
				following: [],
			},
			share: false,
		};
		this.DoSearchSets = this.DoSearchSets.bind(this);
		this.imageAdd = this.imageAdd.bind(this);
		this.coverAdd = this.coverAdd.bind(this);
		this.complete = this.complete.bind(this);
		this.close = this.close.bind(this);
		this.pageSearch = this.pageSearch.bind(this);
		this.share = this.share.bind(this);
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		EventEmitter.emit('/client', {data: 'no value'});

		this.DoSearchSets();
	}

	componentWillUnmount() {
	}


	DoSearchSets = async (e) =>{
		this.setState( { sets: '' } );

    const params = new URLSearchParams();

		params.append( 'profile', this.state.profile );
    
		//---- Page
    if( parseInt( this.state.page ) > 0 ) params.append('page', this.state.page );

    const x = await postApi('/api/v2/profile', params);
    if( x.status === 200 ) {
			let username = x.data.User.username.toLowerCase();
			document.title = username.charAt(0).toUpperCase() + username.slice(1) + " Profile - Mix365 Radio";
      this.setState({status: true, user: x.data.User, schedule: x.data.Schedule, sets: x.data.Recent, pagination: x.data.Pagination, donations: x.data.Donations, friends: x.data.Friends?x.data.Friends:{common: [], following: []}});
    }
	}

	imageAdd() {
		this.setState({imageadd: !this.state.imageadd});
	}

	coverAdd() {
		this.setState({coveradd: !this.state.coveradd});
	}

	complete() {
		this.close();
		this.componentDidMount();
	}

	close() {
		this.setState({imageadd: false, coveradd: false, share: false});
	}

	pageSearch = async(e) => {
    //---- Pagination
    let page = 0;
    if( e.target ) if( e.target.id ) page = e.target.id;
    this.setState({page}, () => {
      this.DoSearchSets(e);
    });
  }

	async friends(uid, confirm = 0) {
		const params = new URLSearchParams();
		params.append( 'uid', uid );
		params.append( 'confirm', confirm );
    const x = await postApi('/api/v2/profile/friends', params);
		switch(x.status) {
			case 200:

				/*
				if( x.data.uid2 === this.state.user.uid ) {
					let user = this.state.user;
					user.friend = x.data.active;
					this.setState({user});
				}
				*/
				this.DoSearchSets();

			break;
			case 218:
				if( window.confirm("Are you sure you wish to no longer follow this friend?") ) {
					await this.friends(uid, 1);
				}
			break;
			case 219:
			break;
			default:
			break;
		}
	}

	donation() {
		EventEmitter.emit('/donation/donate', {uid: this.state.user.uid});
	}

	share(e) {
		this.setState({share: e.toLowerCase().replaceAll(' ','_')});
	}

	render() {
		const user = this.context;
		//let _date = Math.floor(Date.now()/1000);
		let width = 180;
		if( user?.user?.access?.level>=20) width = 240;

		let country = '';
		if( this.state.user?.country_default ) {
			country = this.state.user.country_default.toString();
			if( country && country.indexOf('/') > 0 ) {
				country = country.split('/')[1];
			}
		}

		const schedule = 
      Object.keys(this.state.schedule).map((e,i) => {
        return (
					<React.Fragment key={i}>
						<ScheduleDate schedule={this.state.schedule[e]} />
						<div className="col-12" /*onMouseEnter={()=>this.schedulehover(e)} onMouseLeave={()=>this.schedulehover(0)}*/>
							<div className={`p-schedule-event ${this.state.schedule[e].cancelled===1&&this.state.schedule[e].dummy===0?'p-schedule-event-cancelled':''}`}>
								<Row>
									<div className="text-vcenter" style={{width:180}}>
										{moment(this.state.schedule[e].start*1000).format("HH:mm - ")}
										{moment(this.state.schedule[e].end*1000).format("HH:mm")}
										&nbsp;{DateTime.local().toFormat('ZZZZ')}
									</div>
									<div className="p-schedule-event-image">
										<img src={`https://mix365.co.uk/${this.state.schedule[e].avatar}`} width="84" height="84" alt="profile avatar" />
									</div>
									<Col className="p-schedule-event-right text-vertical">
										<div>
											<Link to={this.state.schedule[e].username===null?'#':`/${this.state.schedule[e].username.toLowerCase().replaceAll(' ','_')}`} className="pb-4">
												{this.state.schedule[e].djtitle?this.state.schedule[e].djtitle:this.state.schedule[e].title?this.state.schedule[e].title:this.state.schedule[e].username}
											</Link>{this.state.schedule[e].cancelled===1 && this.state.schedule[e].dummy===0 && <>&nbsp;&nbsp;Cancelled</>}<br />
											{this.state.schedule[e].description && <><span className="p-schedule-description">{this.state.schedule[e].description}</span></>}
											<Genres genres={this.state.schedule[e].genres} />
										</div>
									</Col>
									<div style={{width}} className="text-vcenter">
										<div>
											{user.user.user.id===3&&<><small>schedule: {this.state.schedule[e].id}, uid: {this.state.schedule[e].uid}&nbsp;&nbsp;</small><br/></>}
											<ButtonGroup size="sm">
												
												{parseInt(this.state.schedule[e].pid) > 0 ?
													<Button onClick={()=>this.share(`/${this.state.schedule[e].pid}/${this.state.schedule[e].showname}`)}><FontAwesomeIcon icon="cloud-arrow-up" />&nbsp;Share</Button>
												:
													<>
														{parseInt(this.state.schedule[e].sid) > 0 &&
															<Button onClick={()=>this.share(`/${this.state.schedule[e].location}/${this.state.schedule[e].username}`)}><FontAwesomeIcon icon="cloud-arrow-up" />&nbsp;Share</Button>
														}
													</>
												}
												{(user.user.user.id === this.state.schedule[e].uid || user.user.admin?.admin_access) &&
													<Button onClick={()=>this.scheduleEdit(e)}><FontAwesomeIcon icon="bars" />&nbsp;Edit</Button>
												}
											</ButtonGroup>
										</div>
									</div>
								</Row>
							</div>
						</div>
					</React.Fragment>
        )
      })
		const previous = 
      Object.keys(this.state.sets).map((e,i) => {
        return (
					<Col md={4} key={i}>
						<AudioBox audio={this.state.sets[e]} />
					</Col>
        )
      })
		const donations = 
			Object.keys(this.state.donations).map((e,i) => {
				return (
					<React.Fragment key={i}>
						{this.state.donations[e].status === 1 &&
							<Col className="text-center">
								<a href={this.state.donations[e].option1} target="_blank" rel="noreferrer">
									{this.state.donations[e].type === 1 &&
										<img src="/images/paypal.png" alt="Donate via Paypal" width="30%" />
									}
									{this.state.donations[e].type === 2 &&
										<img src="/images/ko-fi.png" alt="Donate via Ko-fi" width="30%" />
									}<br />
									<Button size="sm mt-3">Donate</Button>
								</a><br />
							</Col>
						}
					</React.Fragment>
				)
			})
		const followers = 
			Object.keys(this.state.friends.following).slice(0, 10).map((e,i) => {
				return (
					<div className="profile-following" style={{left: i*20+20}}>
						<OverlayTrigger key="listening" placement="top" overlay={
								<Tooltip id="tooltip-user">{this.state.friends.following[e].title?this.state.friends.following[e].title:this.state.friends.following[e].username}</Tooltip>
							}><Link to={`/${this.state.friends.following[e].username.toLowerCase().replaceAll(' ','_')}`} ><img src={`https://mix365.co.uk${this.state.friends.following[e].avatar}`} alt="Profile" /></Link>
						</OverlayTrigger>
						
						{/*<AudioBox audio={this.state.sets[e]} />*/}
					</div>
				)
			})
		return (
			<>
				{this.state.status && this.state.user &&
					<>
						<div className="profile-intro" style={{backgroundImage: `url(https://mix365.co.uk${this.state.user.cover.replaceAll(' ','%20')}`}}>
							<div className="profile-background"></div>
						</div>
						<div className="profile-article">
							<div className="" style={{paddingTop: 0, paddingBottom: 0}}>
							
								<Row className="">
									<Col>
										<div style={{position: 'relative'}}>
											<div style={{position: 'absolute', right: 30, bottom: 10}}>
												<Button size="sm" onClick={this.coverAdd}><FontAwesomeIcon icon="image" /> Upload Cover</Button>
											</div>
										</div>
									</Col>
								</Row>

								<Row className="profile">
									<Col xs={1} className="d-none d-md-block"></Col>
									<Col xs={4} className="profile-block">
										<div className="profile-avatar">
											<div className="profile-avatar-inner">
												<img src={`https://mix365.co.uk${this.state.user.avatar}`} alt="Profile Avatar" />
											</div>
										</div>
									</Col>
									<Col className="pt-2 ps-4">
										<Row className="gx-0">
											<Col xs={12} md={6}>
												{this.state.user.title?this.state.user.title:this.state.user.username}<br />
												{this.state.user.level}{/*<br />
												0 Followers*/}
											</Col>
											<Col xs={12} md={6} className="pt-2 pe-5 text-right">
												<ButtonGroup size="sm">
													{this.state.user?.uid !== user.user?.user?.id &&
														<Button onClick={()=>this.friends(this.state.user.uid)}>{this.state.user.friend===1?<>Following <FontAwesomeIcon icon="check" /></>:<>Follow</>}</Button>
													}
													<Button size="sm" onClick={()=>this.share(`/${this.state.user.username}`)}>Share</Button>
													{(user.user?.user?.id === this.state.user?.uid || user.user.admin?.admin_access) &&
														<Link to={`/settings/${this.state.profile}`}><Button size="sm">Settings</Button></Link>
													}
												</ButtonGroup>		
											</Col>
										</Row>
									</Col>
								</Row>
							</div>
						</div>

						<div className="profile-splitter text-center" style={{marginTop: 312}}>
							<div className="profile-splitter-background"></div>
							<h2 className="profile-splitter-text">
								
							</h2>
						</div>

						<div className="article">

							<Row>
								<Col md={2}>
									<div className="weeklydjs-card mb-5" style={{}}>
										<div className="weeklydjs-avatar" style={{position: 'relative'}}>
											<img src={`https://mix365.co.uk/${this.state.user.avatar}`} alt="DJ Profile Avatar" className="weeklydjs-avatar-img" width="100%" />
											<div className="profile-upload-profile">
												<Button size="sm" onClick={this.imageAdd}><FontAwesomeIcon icon="image" /> Upload</Button>
											</div>
										</div>
										<Row className="home-nl-bottom gx-0">
											<Col xs={12}>
												{this.state.user.title?this.state.user.title:this.state.user.username}<br />
											</Col>
											<Col xs={12} className="profile-country">
												<FontAwesomeIcon icon="location-dot" /> {country}<br />
												<FontAwesomeIcon icon={['far', 'clock']} /> Joined {moment(this.state.user.joined*1000).format("Do MMMM YYYY")}
											</Col>
							
											<Col xs={12}>
												<ul className="weeklydjs-socials">
													{this.state.user.facebook &&
														<li>
															<a href={this.state.user.facebook} title="Facebook" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.instagram &&
														<li>
															<a href={this.state.user.instagram} title="Instagram" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.mixcloud &&
														<li>
															<a href={this.state.user.mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.soundcloud &&
														<li>
															<a href={this.state.user.soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.twitch &&
														<li>
															<a href={this.state.user.twitch} title="Twitch" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
															</a>
														</li>
													}
													{this.state.user.youtube &&
														<li>
															<a href={this.state.user.youtube} title="Youtube" target="_blank" rel="noreferrer">
																<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
															</a>
														</li>
													}
												</ul>
											</Col>
										</Row>
									</div>
									{/*<div className="weeklydjs-card" style={{}}>
										<div className="weeklydjs-avatar" style={{position: 'relative'}}>
											
										</div>
										<Row  className="home-nl-bottom gx-0">
											<Col xs={12} className="p-3">
												<ButtonGroup size="sm">
													<Button onClick={()=>this.donation()}>Donate</Button>
												</ButtonGroup>
											</Col>
										</Row>
									</div>*/}
								</Col>

								<Col>
									{this.state.user.biography.length > 0&&
										<>
											<h3 className="profile-heading">About</h3>
											<p>{this.state.user.biography}</p><br />
										</>
									}
									<h3 className="profile-heading">Statistics</h3>
									<p>
										<Row className="gx-0 pt-2">
											<Col className="text-center">
												<FontAwesomeIcon icon="compact-disc" style={{fontSize:22}} /><br />
												Sets: {this.state.user.performances}
											</Col>
											<Col className="text-center">
												<FontAwesomeIcon icon="play" style={{fontSize:22}} /><br />
												Live: {this.state.user.listeners}<br />
												Replay: {this.state.user.replay}
											</Col>
											<Col className="text-center">
												<FontAwesomeIcon icon="heart" style={{fontSize:22}} /><br />
												Favorites: {this.state.user.favorites}
											</Col>
											<Col className="text-center">
												<FontAwesomeIcon icon="thumbs-up" style={{fontSize:22}} /><br />
												Likes: {this.state.user.likes}
											</Col>
											<Col className="text-center">
												<FontAwesomeIcon icon="hourglass-empty" style={{fontSize:22}} /><br />
												Hours: {this.state.user.hours}
											</Col>
										</Row>
									</p><br />
									{Object.keys(this.state.donations).length > 0 &&
										<>
											<h3 className="profile-heading">Donate</h3>
											<p>
												{this.state.user.donation.length === 0 ?
													<>To support me and help me doing what im doing, please donate via the follow link(s):</>
												:
													<>{this.state.user.donation}</>
												}
											</p>
											<Row className="gx-0">
												{donations}
											</Row>
											<br />
										</>
									}
									{Object.keys(this.state.schedule).length > 0 &&
										<>
											<h3 className="profile-heading">Upcoming Sets</h3>
											<p>{schedule}</p><br />
										</>
									}
									{Object.keys(this.state.sets).length > 0 &&
										<>
											<h3 className="profile-heading">Previous Sets</h3>
											<Row>
												<Col xs={12}>
													<Pagination pagination={this.state.pagination} function={this.pageSearch} />
												</Col>
												{previous}
											</Row><br />
										</>
									}
								</Col>

								<Col md={3}>
									{this.state.user.genres.length > 0&&
										<>
											<h3 className="profile-heading">Genres</h3>
											<p><Genres genres={this.state.user.genres} /></p><br /><br />
										</>
									}
									<h3 className="profile-heading">Live</h3>
									<p></p><br />
									<h3 className="profile-heading">Following</h3>
									{Object.keys(this.state.friends.following).length === 0 &&
										<>No one following yet!<br /></>
									}
									{Object.keys(this.state.friends.following).length === 1 &&
										<>1 person is following {this.state.user.title?this.state.user.title:this.state.user.username}<br /></>
									}
									{Object.keys(this.state.friends.following).length > 1 &&
										<>{Object.keys(this.state.friends.following).length} people are following {this.state.user.title?this.state.user.title:this.state.user.username}<br /></>
									}
									{followers}
									<p></p><br />
								</Col>

							</Row>
						</div>
					</>
				}
				{this.state.imageadd && <Avatar show={this.state.imageadd} close={this.close} complete={()=>{this.complete();}} uid={this.state.user.uid} /> }
				{this.state.coveradd && <Cover show={this.state.coveradd} close={this.close} complete={()=>{this.complete();}} uid={this.state.user.uid} /> }
				{this.state.share!==false && <Share url={this.state.share} show={this.state.share.length>0} close={this.close} /> }
			</>
		);
	}
}
